module.exports = __webpack_public_path__ + "img/boy_1.05737197.svg";